import React, {useEffect, useRef, useState} from 'react';
import { Row, Col, Card, Button, Form } from 'react-bootstrap';
import {add, listType} from '../../../lib/api/staff';
import {list} from "../../../lib/api/federation";
import {listForeigner, listPosition} from "../../../lib/api/player";

export function Add({ onClose, onSave }) {
  const [staffType, setStaffType] = useState([]);

  const [previewImage, setPreviewImage] = useState(process.env.REACT_APP_BASE_API_URL +"/uploads/blank.jpg");
  const fileInputRef = useRef(null);

  const [errors, setErrors] = useState({
    name: false,
    last_name: false,
    staff_type_id: false,
  });

  useEffect(() => {
    (async () => {
      const resStaffType = await listType();
      setStaffType(resStaffType);
    })();
  }, []);

  const handleSubmit = async event => {
    event.preventDefault();
    const form = event.currentTarget;
    if (!validateForm(event)) return;

    const _data = {
      name: form.name.value,
      last_name: form.last_name.value,
      staff_type_id: form.staff_type_id.value,
      descreption: form.descreption.value,
      image: form.image.files[0]
    };

    console.clear()
    console.log('_data',_data)

    await add(_data);
    onSave();
    onClose();
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setPreviewImage(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const validateForm = event => {
    const form = event.currentTarget;
    const newErrors = {
      name: !form.name.value.trim(),
      last_name: !form.last_name.value.trim(),
      staff_type_id: !form.staff_type_id.value,
    };
    setErrors(newErrors);

    if (Object.values(newErrors).some(error => error)) {
      event.stopPropagation();
      return false;
    }
    return true;
  };

  return (
      <Card>
        <Card.Body className="bg-body-tertiary">
          <Form
              method="POST"
              encType="multipart/form-data"
              noValidate
              onSubmit={handleSubmit}
          >
            <Row className="mb-3">
              <Col md="6">
                <Form.Label>Slika</Form.Label>
                <div
                    onClick={() => fileInputRef.current?.click()}
                    style={{
                      cursor: 'pointer',
                      width: 120,
                      height: 120,
                      borderRadius: '50%',
                      overflow: 'hidden',
                      border: '2px dashed #ccc',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                >
                  {previewImage ? (
                      <img src={previewImage} alt="Preview" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  ) : (
                      <span className="text-muted">Klikni za sliku</span>
                  )}
                </div>
                <Form.Control
                    type="file"
                    name="image"
                    accept="image/*"
                    style={{ display: 'none' }}
                    ref={fileInputRef}
                    onChange={handleImageChange}
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} md="12" controlId="staff_type_id">
                <Form.Label>Vrsta</Form.Label>
                <Form.Select name="staff_type_id" isInvalid={errors.staff_type_id}>
                  <option value="">Izaberite</option>
                  {staffType.map(p => <option key={p.staff_type_id} value={p.staff_type_id}>{p.name}</option>)}
                </Form.Select>
                <Form.Control.Feedback type="invalid">Molimo unesite nivo vrstu.</Form.Control.Feedback>
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} md="6" controlId="name">
                <Form.Label>Ime</Form.Label>
                <Form.Control required type="text" name="name" isInvalid={errors.name} />
                <Form.Control.Feedback type="invalid">Molimo unesite ime.</Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="last_name">
                <Form.Label>Prezime</Form.Label>
                <Form.Control required type="text" name="last_name" isInvalid={errors.last_name} />
                <Form.Control.Feedback type="invalid">Molimo unesite prezime.</Form.Control.Feedback>
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group className="mb-3" controlId="descreption">
                <Form.Label>Opis</Form.Label>
                <Form.Control as="textarea" name="descreption" rows={3} />
              </Form.Group>
            </Row>

            <Button type="submit">Sačuvaj</Button>
          </Form>
        </Card.Body>
      </Card>
  );
}
